import React from "react";
import { compose } from "recompose";
import { withCookies } from "react-cookie";
import Modal from "theme/components/organisms/Modal";
import { Select } from "theme/components/atoms/Form/Input";
import { defineMessages, injectIntl, useIntl } from "react-intl";

const messages = defineMessages({
  chooseYourStore: {
    id: "modules.User.Address.CountrySelectorPopin.chooseYourStore",
    defaultMessage: "Choose your store",
  },
  usAndCanada: {
    id: "modules.User.Address.CountrySelectorPopin.usAndCanada",
    defaultMessage: "US AND CANADA",
  },
  europeAndMiddleEastForFrench: {
    id: "modules.User.Address.CountrySelectorPopin.europeAndMiddleEastForFrench",
    defaultMessage: "EUROPE AND MIDDLE EAST FOR FRENCH",
  },
  europeAndMiddleEastForEnglish: {
    id: "modules.User.Address.CountrySelectorPopin.europeAndMiddleEastForEnglish",
    defaultMessage: "EUROPE AND MIDDLE EAST FOR ENGLISH",
  },
  europeAndMiddleEast: {
    id: "modules.User.Address.CountrySelectorPopin.europeAndMiddleEast",
    defaultMessage: "EUROPE AND MIDDLE EAST",
  },
  chooseYourLanguage: {
    id: "modules.User.Address.CountrySelectorPopin.chooseYourLanguage",
    defaultMessage: "Choose your language",
  },
  french: {
    id: "modules.User.Address.CountrySelectorPopin.french",
    defaultMessage: "French",
  },
  english: {
    id: "modules.User.Address.CountrySelectorPopin.english",
    defaultMessage: "English",
  },
});

const CountrySelectorPopin = (props) => {
  const intl = useIntl();
  const needToDisplayPopin = !props.cookies.get("country_selector_popin");

  if (typeof window === "undefined" || !needToDisplayPopin) {
    return null;
  }

  const closeModal = (e) => {
    e.preventDefault();
    props.cookies.set("country_selector_popin", true);
    window.location.href = e.currentTarget.href;
  };

  return (
    <>
      <Modal
        className="country-selector-popin"
        appearance="full"
        isOpen={needToDisplayPopin}
        children={
          <>
            <div>
              <p className="country-selector-popin__title">
                {intl.formatMessage(messages.chooseYourStore)}
              </p>
              <div className="country-selector-popin__stores md-hidden">
                <div className="country-selector-popin__store">
                  <p className="country-selector-popin__store-title">
                    {intl.formatMessage(messages.usAndCanada)}
                  </p>
                  <a href="/us" onClick={(e) => closeModal(e)}>
                    <img src="/images/north-america.svg" alt="United States" />
                  </a>
                </div>

                <div className="country-selector-popin__store">
                  <p className="country-selector-popin__store-title">
                    {intl.formatMessage(messages.europeAndMiddleEast)}
                  </p>
                  <a href="/" onClick={(e) => closeModal(e)}>
                    <img src="/images/europe-middle-east.svg" alt="Europe" />
                  </a>
                  <Select
                    options={[
                      {
                        label: intl.formatMessage(messages.chooseYourLanguage),
                        value: "/",
                      },
                      {
                        label: intl.formatMessage(messages.french),
                        value: "/",
                      },
                      {
                        label: intl.formatMessage(messages.english),
                        value: "/en",
                      },
                    ]}
                    onChange={(e) => {
                      props.cookies.set("country_selector_popin", true);
                      window.location.href = e;
                    }}
                  />
                </div>
              </div>
              <div className="country-selector-popin__stores md-visible">
                <div className="country-selector-popin__store">
                  <Select
                    options={[
                      { label: "-", value: "/" },
                      {
                        label: intl.formatMessage(messages.usAndCanada),
                        value: "/us",
                      },
                      {
                        label: intl.formatMessage(
                          messages.europeAndMiddleEastForFrench
                        ),
                        value: "/",
                      },
                      {
                        label: intl.formatMessage(
                          messages.europeAndMiddleEastForEnglish
                        ),
                        value: "/en",
                      },
                    ]}
                    onChange={(e) => {
                      props.cookies.set("country_selector_popin", true);
                      window.location.href = e;
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        }
        onRequestClose={closeModal}
      />
    </>
  );
};

export default compose(withCookies, injectIntl)(CountrySelectorPopin);
